<template>
   <v-snackbar
      :value="sbar"
      :color="sbcolor"
      :timeout="timeout"
      :absolute="!$vuetify.breakpoint.mobile"
      :centered="!$vuetify.breakpoint.mobile"
      :bottom="$vuetify.breakpoint.mobile"
      elevation="24"
      transition="slide-y-transition"
      multi-line
   >
      <template
         ><h3>{{ message }}</h3></template
      >
      <template v-slot:action="{ attrs }">
         <v-icon color="white" v-bind="attrs" @click="sbar = false">
            mdi-close
         </v-icon>
      </template>
   </v-snackbar>
</template>

<script>
   export default {
      data() {
         return {
            sbar: false,
            message: "",
            timeout: 3000,
            sbcolor: "primary",
         };
      },
      methods: {
         display(msgdata) {
            this.message = msgdata.message || "No message";
            this.timeout = msgdata.timeout || 3000;
            this.sbcolor = msgdata.color || "success";
            this.sbar = true;
            setTimeout(() => {
               this.sbar = false;
            }, this.timeout);
         },
      },
   };
</script>
